import { getData } from '../api';
import {
	SeatsChartsResponse,
	SeatsIOEvent,
	SeatsIOAvailabilityReport,
	SeatsChartDetails,
	SeatsChartChangePreview,
} from './types';

export const getSeatsCharts = async (): Promise<SeatsChartsResponse> => {
	return await getData('/seats/charts');
};

export const getSeatsChart = async (chartKey: string): Promise<SeatsChartDetails> => {
	return getData(`/seats/charts/${chartKey}`);
};

export const getSeatsIOEvent = async (eventKey: string): Promise<SeatsIOEvent> => {
	return getData(`/seats/events/${eventKey}`);
};

export const getSeatsIOEventReport = async (eventKey: string): Promise<SeatsIOAvailabilityReport> => {
	return getData(`/seats/events/${eventKey}/report`);
};

export const getSeatsChartChangePreview = async (
	eventId: string,
	newChartKey: string
): Promise<SeatsChartChangePreview> => {
	return getData(`/events/${eventId}/seats/chart-change-preview?new_chart_key=${encodeURIComponent(newChartKey)}`);
};

export * from './types';
